import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InternationalTradeEconRev = _resolveComponent("InternationalTradeEconRev")!
  const _component_InvestmentsWorldEconRev = _resolveComponent("InvestmentsWorldEconRev")!
  const _component_EconRevTemplate = _resolveComponent("EconRevTemplate")!

  return (_openBlock(), _createBlock(_component_EconRevTemplate, null, {
    default: _withCtx(() => [
      _createVNode(_component_InternationalTradeEconRev, {
        countryId: $props.countryId,
        yearValue: $data.year,
        "onUpdate:yearValue": _cache[0] || (_cache[0] = ($event: any) => (($data.year) = $event)),
        notForTecRussiaTab: ""
      }, null, 8, ["countryId", "yearValue"]),
      _createVNode(_component_InvestmentsWorldEconRev, {
        countryId: $props.countryId,
        year: $data.year,
        notForTecRussiaTab: ""
      }, null, 8, ["countryId", "year"])
    ]),
    _: 1
  }))
}